export default "__VITE_ASSET__b54fb7c9__"